import React, { useEffect, useState, useRef } from "react";
import NoDataItem from "../NoDataItem";
import { BsDownload } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorPage from "../../../../Components/ErrorPage";
import { TbGalaxy, TbLogs, TbReload } from "react-icons/tb";
import * as XLSX from "xlsx";

const LogsMain = ({ fetchRecords, records, dbName }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const { project_id, db_id, coll_id } = useParams();
    const [collName, setCollName] = useState(null)
    const [loadingCollectionLogs, setLoadingCollectionLogs] = useState(true);
    const [error, setError] = useState(false);
    const [collectionDataLogs, setCollectionDataLogs] = useState([]);
    const lastLogRef = useRef(null);

    const title_empty = "Create your firts collection to view the logs"
    const title_item = "Choose a collection to view the logs"
    const subtitle_empty = "You can view all the logs related to the operations performed on a specific collection."

    const title_empty_col = "No logs available for this collection!"
    const subtitle_empty_col = "Logs related to the operations performed on this collection will be updated automatically."
    const img_empty_col = "logs"

    useEffect(() => {
        if (project_id && db_id && coll_id) {
            fetchCollectionLogs(user_id, db_id, coll_id)
        }
    }, [user_id, project_id, db_id, coll_id]);

    const handleOpenCollectionLogs = (coll_id) => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/logs/${coll_id}`);
    };

    const fetchCollectionLogs = async (user_id, db_id, coll_id) => {
        setLoadingCollectionLogs(true);
        try {
            const response = await fetch("https://backend.erioon.com/get_main_logs", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, db_id, coll_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const collection = result.records || [];
                if (Array.isArray(collection)) {
                    setCollectionDataLogs(collection);
                } else {
                    throw new Error("Invalid response format");
                }
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load files.");
            }
            setLoadingCollectionLogs(false);
        } catch (err) {
            setLoadingCollectionLogs(false);
            setError("Failed to connect to the server. Please try again later.");
        } finally {
            setLoadingCollectionLogs(false);
        }
    };

    useEffect(() => {
        if (lastLogRef.current) {
            lastLogRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [collectionDataLogs]);

    const handleDownloadLogs = () => {
        if (collectionDataLogs.length === 0) return;

        const formattedData = collectionDataLogs.map((log, index) => ({
            timestamp: log.timestamp,
            method: log.method,
            type: log.type,
            log: log.log,
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData, {
            header: ["timestamp", "method", "type", "log"],
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");

        const fileName = `logs_${dbName}_${collName}.xlsx`; // Note: Avoid slashes in filenames
        XLSX.writeFile(workbook, fileName);
    };


    if (error) {
        return <ErrorPage />;
    }

    return (
        records.some(record =>
            record.collections &&
            Object.keys(record.collections).length > 0
        ) ? (
            <div className="logs_container fade-in">
                <div className="logs_header">
                    {collectionDataLogs.length > 0 && (
                        <div className="logs_header_inner">
                            <button className="download_logs_btn" onClick={() => fetchCollectionLogs(user_id, db_id, coll_id)}>
                                <i>
                                    <TbReload />
                                </i>
                            </button>
                            <button className="download_logs_btn" onClick={handleDownloadLogs}>
                                <i>
                                    <BsDownload />
                                </i>{" "}
                                Download logs
                            </button>
                        </div>
                    )}
                </div>
                <div className="logs_body_main fade-in">
                    <div className="open_db_main_sidebar_opened">
                        <div className="open_db_main_sidebar_header">
                            <div className="open_db_main_sidebar_header_title">
                                <p>
                                    <TbLogs /> Logs
                                </p>
                                <button className="open_db_main_sidebar_header_title_btn" onClick={fetchRecords}><TbReload /></button>
                            </div>
                        </div>
                        <div className="open_db_main_sidebar_body">
                            {records.map((record, index) => {
                                const collections = record.collections;

                                const collectionsArray =
                                    collections && typeof collections === "object"
                                        ? Object.values(collections)
                                        : [];

                                return collectionsArray.map((collection) => (
                                    <div
                                        key={collection.coll_id}
                                        className={`open_db_main_sidebar_body_link ${coll_id == collection.coll_id
                                            ? "open_db_main_sidebar_body_link_selected"
                                            : ""
                                            }`}
                                    >
                                        <p onClick={() => { handleOpenCollectionLogs(collection.coll_id); setCollName(collection.coll_name) }}>
                                            - {collection.coll_name}
                                        </p>
                                    </div>
                                ));
                            })}
                        </div>

                    </div>
                    <div className="logs_body_main_cont">

                        <div className="logs_body">
                            {coll_id ? (
                                loadingCollectionLogs ? (
                                    <div className="body_loading_db_cont">
                                        <div className="loading_logo_erioon">
                                            <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                                        </div>
                                    </div>
                                ) : (
                                    collectionDataLogs.length > 0 ? (
                                        <>
                                            {collectionDataLogs.map((log, index) => {
                                                const isError = log.type === "ERROR";

                                                // Function to safely convert any value to a string without showing '[Object Object]'
                                                const safeString = (value) => {
                                                    if (typeof value === 'object' && value !== null) {
                                                        return JSON.stringify(value); // Convert object to a string (optional, could display more meaningful info)
                                                    }
                                                    return String(value); // Convert primitive values directly to string
                                                };

                                                return (
                                                    <div
                                                        key={index}
                                                        className={`log_item fade-in ${isError ? "log_item_error" : "log_item_success"}`}
                                                    >
                                                        <div className="inner_log_item_first">
                                                            <p className="log_item_single log_item_timestamp">
                                                                {log.timestamp && safeString(log.timestamp)}
                                                            </p>
                                                            <p className="log_item_single log_item_method">
                                                                {log.method && safeString(log.method)}
                                                            </p>
                                                            <p
                                                                className={`log_item_single log_item_type ${isError ? "log_item_type_error" : "log_item_type_success"}`}
                                                            >
                                                                {log.type && safeString(log.type)}
                                                            </p>
                                                        </div>
                                                        <div className="inner_log_item_second">
                                                            <p className="log_item_log">
                                                                {log.log && safeString(log.log)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <NoDataItem
                                            fetchRecords={fetchRecords}
                                            title={title_empty_col}
                                            subtitle={subtitle_empty_col}
                                            item={img_empty_col}
                                            showBtn={false}
                                        />
                                    )
                                )
                            ) : (
                                <NoDataItem
                                    fetchRecords={fetchRecords}
                                    title={title_item}
                                    subtitle={subtitle_empty}
                                    item={img_empty_col}
                                    showBtn={false}
                                />
                            )}

                            {/* <div ref={lastLogRef} /> */}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <NoDataItem
                fetchRecords={fetchRecords}
                title={title_empty}
                subtitle={subtitle_empty}
                item={img_empty_col}
                showBtn={false}
            />
        )

    );
};

export default LogsMain;
